import { graphql } from "relay-runtime"

export const deCreateProgressNoteMutation = graphql`
  mutation deCreateProgressNoteMutation($input: De_createProgressNoteInput!, $addConnections: [ID!]!) {
    createProgressNote: de_createProgressNote(input: $input) {
      progressNoteMutationOutput: de_ProgressNoteMutationOutput {
        progressNote @prependNode(connections: $addConnections, edgeTypeName: "de_ProgressNoteEdge") {
          ...deProgressNoteFragment @relay(mask: false)
          ...deProgressNoteFragment
        }
        episodeOfCare {
          updatedAt
        }
      }
    }
  }
`
